export const kiloCaloriesToKilojouleFactor: number = 4.184;
